<template>
  <div id="app">
    <header>
      <div v-responsive.sm.xs id="miniTitanNavigation">
        <div id="miniTnActions" class="flex_display">
          <div id="miniTnLeftActions" class="div_aline_left flex_display">
            <div id="miniTnMenuToggle" v-on:click="toggleMiniMenu">
              <div class="navigation_circle_style navigation_menu_bar flex_display transparent_bg navigation_mini_icon">
                <span>
                  <i class="fas fa-bars" aria-hidden="true"></i>
                </span>
              </div>
            </div>
            <div id="miniTnLogo">
              <img class="navigation_logo" src="../../assets/image/neoncrm_logo_dark.svg"/>
            </div>
          </div>
          <div id="miniTnRightActions" class="div_aline_right flex_display">
            <div id="miniTnIconBtns" class="flex_display">
              <b-dropdown right variant="link" no-caret class="bootstrap_button_dropdown bootstrap_mini_create_new">
                <template slot="button-content">
                  <div class="navigation_circle_style navigation_mini_icon flex_display transparent_bg">
                <span>
                  <i class="fas fa-cog" aria-hidden="true"></i>
                </span>
                  </div>
                </template>
                <b-dropdown-item class="neon_dropdown_item" href="#">System Settings Home</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">Organization Profile</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">2-Step Verification</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">User Groups/Permissions</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">System Users</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">Data Backup Utility</b-dropdown-item>
              </b-dropdown>

              <div v-on:click="toggleMiniSearchBox" class="navigation_circle_style navigation_mini_icon flex_display transparent_bg" v-bind:class="{ mini_search_active: miniSearchBox, mini_search_hide: !miniSearchBox }">
                    <span>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </span>
              </div>

              <div id="tnaMiniIconNotification" class="flex_display">
                <div class="navigation_circle_style navigation_mini_icon flex_display transparent_bg flex_display_centered_child_vertical" v-on:click="hidenc()">
                  <span>
                    <i class="fas fa-bell" aria-hidden="true"></i>
                  </span>
                </div>

                <div class="notification_mini_shake_number navigation_circle_style flex_display shake" v-on:click="shakeit()">
                  <span class="navigation_notification_center_label">
                    99
                  </span>
                </div>
              </div>

              <b-dropdown right variant="link" no-caret class="bootstrap_button_dropdown bootstrap_mini_create_new">
                <template slot="button-content">
                  <div class="navigation_circle_style mini_navigation_create_action flex_display">
                    <span>
                      <i class="fas fa-plus-circle" aria-hidden="true"></i>
                    </span>
                  </div>
                </template>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Individual</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Organization</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Donation</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Event Registration</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Store Order</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Membership</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Pledge</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Activity</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
        <div v-if='miniSearchBox' v-clickoutside="toggleMiniSearchBox" id="miniTnSearch">
          <div class="mini_navigation_search_container flex_display">
            <div class="neon_search_result demo_search_select_mini snipped flex_display_centered_child">
              <i aria-hidden="true" class="fas fa-search tital_search_icon"></i>
              <multiselect
                :options="searchResults"
                :multiple="true"
                group-values="results"
                group-label="type"
                :group-select="true"
                :close-on-select="false"
                track-by="trackId"
                label="trackId"
                placeholder="Search by Name, ID or Email"
                :max-height="1000"
                :show-labels="false"
                :internal-search="false"
                :clear-on-select="true"
                :hide-selected="false"
                @search-change="getResult"
                @close="clearResult">
                <template slot="option" slot-scope="props">
                  <div v-if="props.option.$isLabel" class="search_result_group_bar">
                    <span class="search_result_group_bar_label">{{props.option.$groupLabel}}</span>
                  </div>
                  <div v-else-if="!props.option.isGroup && props.option.type === 'Accounts'" class="search_result_item flex_display">
                    <div class="flex_display search_result_item_icon">
                      <div class="flex_display_centered_child">
                        <i class="fas fa-plus-circle" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="search_result_item_content">
                      <div class="search_result_item_content_title"><a v-on:click="closeSearch()">{{ props.option.displayName }}</a></div>
                      <div class="search_result_item_content_description">{{ props.option.accountType }}</div>
                    </div>
                  </div>
                  <div v-else-if="!props.option.isGroup && props.option.type === 'Households'" class="search_result_item flex_display">
                    <div class="flex_display search_result_item_icon">
                      <div class="flex_display_centered_child">
                        <i class="fas fa-plus-circle" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="search_result_item_content">
                      <div class="search_result_item_content_title"><a v-on:click="closeSearch()">{{ props.option.householdName }}</a></div>
                      <div class="search_result_item_content_description">{{ props.option.householdDescription }}</div>
                    </div>
                  </div>
                  <div v-else-if="!props.option.isGroup && props.option.type === 'Campaigns'" class="search_result_item flex_display">
                  <span class="option__title">
                    {{ props.option.displayName }}
                  </span>
                  </div>
                  <div v-else-if="!props.option.isGroup && props.option.type === 'Events'" class="search_result_item flex_display">
                  <span class="option__title">
                    {{ props.option.displayName }}
                  </span>
                  </div>
                  <div v-else-if="!props.option.isGroup && props.option.type === 'showMore'" class="search_result_show_more flex_display">
                    <a  v-on:click="closeSearch()" class="search_result_show_more_link div_aline_right">Show more </a>
                  </div>
                </template>
                <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
              </multiselect>
            </div>
          </div>
          <span class="mini_advanced_search_icon">
            <i class="fas fa-sliders-h" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div v-responsive.md.lg.xl id="titanNavigation">
        <div id="tnActions" class="flex_display">
          <div id="tnLeftActions" class="div_aline_left flex_display">
            <div id="tnaLogo">
              <img class="navigation_logo" src="../../assets/image/neoncrm_logo_dark.svg"/>
            </div>
            <div id="tnaSearchBox" class="flex_display">
              <div class="neon_search_result demo_search_select snipped flex_display_centered_child">
                <i aria-hidden="true" class="fas fa-search tital_search_icon"></i>
                <multiselect
                  :options="searchResults"
                  :multiple="true"
                  group-values="results"
                  group-label="type"
                  :group-select="true"
                  :close-on-select="false"
                  track-by="trackId"
                  label="trackId"
                  placeholder="Search by Name, ID or Email"
                  :max-height="1000"
                  :show-labels="false"
                  :internal-search="false"
                  :clear-on-select="true"
                  :hide-selected="false"
                  @search-change="getResult"
                  @close="clearResult">
                  <template slot="option" slot-scope="props">
                    <div v-if="props.option.$isLabel" class="search_result_group_bar">
                      <span class="search_result_group_bar_label">{{props.option.$groupLabel}}</span>
                    </div>
                    <div v-else-if="!props.option.isGroup && props.option.type === 'Accounts'" class="search_result_item flex_display">
                      <div class="flex_display search_result_item_icon">
                        <div class="flex_display_centered_child">
                          <i class="fas" v-bind:class="{ 'fa-user': props.option.accountType === 'individual', 'fa-users': props.option.accountType !== 'individual' }" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="search_result_item_content">
                        <div class="search_result_item_content_title"><a v-on:click="closeSearch()">{{ props.option.displayName }}</a></div>
                        <div class="search_result_item_content_description">{{ props.option.accountType }}</div>
                      </div>
                    </div>
                    <div v-else-if="!props.option.isGroup && props.option.type === 'Households'" class="search_result_item flex_display">
                      <div class="flex_display search_result_item_icon">
                        <div class="flex_display_centered_child">
                          <i class="fas fa-home" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="search_result_item_content">
                        <div class="search_result_item_content_title"><a v-on:click="closeSearch()">{{ props.option.householdName }}</a></div>
                        <div class="search_result_item_content_description">{{ props.option.householdDescription }}</div>
                      </div>
                    </div>
                    <div v-else-if="!props.option.isGroup && props.option.type === 'Campaigns'" class="search_result_item flex_display">
                      <div class="flex_display search_result_item_icon">
                        <div class="flex_display_centered_child">
                          <i class="fas fa-bullhorn" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="search_result_item_content">
                        <div class="search_result_item_content_title"><a v-on:click="closeSearch()">{{ props.option.campaignName }}</a></div>
                        <div class="search_result_item_content_description">{{ props.option.campaignDescription }}</div>
                      </div>
                    </div>
                    <div v-else-if="!props.option.isGroup && props.option.type === 'Events'" class="search_result_item flex_display">
                      <div class="flex_display search_result_item_icon">
                        <div class="flex_display_centered_child">
                          <i class="fas fa-calendar" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="search_result_item_content">
                        <div class="search_result_item_content_title"><a v-on:click="closeSearch()">{{ props.option.eventName }}</a></div>
                        <div class="search_result_item_content_description">{{ props.option.eventDescription }}</div>
                      </div>
                    </div>
                    <div v-else-if="!props.option.isGroup && props.option.type === 'showMore'" class="search_result_show_more flex_display">
                      <a  v-on:click="closeSearch()" class="search_result_show_more_link div_aline_right">Show more </a>
                    </div>
                  </template>
                  <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                </multiselect>
              </div>
            </div>
            <div id="tnaAdvancedSearchBox">
              <span class="advanced_search_icon">
                <i class="fas fa-sliders-h" aria-hidden="true"></i>
              </span>
            </div>
          </div>
          <div id="tnRightActions" class="div_aline_right flex_display">
            <div id="tnaNewBtn">
              <div class="navigation_create_action_container">

              </div>
            </div>
            <div id="tnaIconBtns" class="flex_display">

              <b-dropdown right variant="link" no-caret class="bootstrap_button_dropdown flex_display_centered_child_vertical">
                <template slot="button-content">
                  <div class="navigation_circle_style navigation_settings navigation_create_action flex_display">
                    <span>
                      <i class="fas fa-plus-circle" aria-hidden="true"></i>
                    </span>
                  </div>
                </template>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Individual</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Organization</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Donation</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Event Registration</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Store Order</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Membership</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Pledge</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">New Activity</b-dropdown-item>
              </b-dropdown>

              <b-dropdown right variant="link" no-caret class="bootstrap_button_dropdown flex_display_centered_child_vertical">
                <template slot="button-content">
                  <div class="navigation_circle_style navigation_settings flex_display">
                    <span>
                      <i class="fas fa-cog" aria-hidden="true"></i>
                    </span>
                  </div>
                </template>
                <b-dropdown-item class="neon_dropdown_item" href="#">System Settings Home</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">Organization Profile</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">2-Step Verification</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">User Groups/Permissions</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">System Users</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">Data Backup Utility</b-dropdown-item>
              </b-dropdown>
            </div>

            <div id="tnaIconNotification">
              <div class="navigation_circle_style navigation_settings flex_display" v-on:click="hidenc()">
                  <span>
                    <i class="fas fa-bell" aria-hidden="true"></i>
                  </span>
              </div>

              <div class="notification_shake_number navigation_circle_style flex_display shake" v-on:click="shakeit()">
                  <span class="navigation_notification_center_label">
                    99
                  </span>
              </div>
            </div>

            <div id="tnaVerticalLine"></div>

            <div id="tnaInformation">
              <div class="navigation_full_name">
                Edward Nicholas Shen
              </div>
              <div class="navigation_logout">
                <a href="#">log out</a>
              </div>
            </div>

            <div id="tnaMyAccount" v-on:click="toggleMyAccountMenu()" class="flex_display neon_dropdown">

              <b-dropdown right variant="link" no-caret class="bootstrap_button_dropdown bootstrap_my_account" toggle-class="arrow_controller">
                <template slot="button-content">
                  <div class="dropdown_arrow_small flex_display_centered_child">
                  </div>
                </template>
                <b-dropdown-item class="neon_dropdown_item" href="#">Sign-in & Security</b-dropdown-item>
                <b-dropdown-item class="neon_dropdown_item" href="#">Action Log</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
        <div id="tnMenu" class="flex_display">
          <div id="tnLeftMenu" class="flex_display">
            <div v-for="menu in menus" v-if='menu.id !== 999 && menu.show' v-bind:id="menu.module" v-on:click="toggle(menu.module, $event)" class="navigation_menu" v-bind:class="{ menu_active: menu.isActive, menu_hide: !menu.isActive }">
              <div class="flex_display navigation_menu_label_container">
                <span class="navigation_menu_label flex_display_centered_child" v-bind:class="{ has_submenu: menu.subMenu !== undefined && menu.subMenu !== null }">
                  {{menu.displayName}}
                </span>

                <div class="flex_display notification_menu_expand_arrow">
                  <div v-if='menu.subMenu !== undefined && menu.subMenu !== null' class="flex_display_centered_child flex_display" v-bind:class="{ open: menu.isActive }">
                    <span class="notification_menu_expand_arrow_left"></span>
                    <span class="notification_menu_expand_arrow_right"></span>
                  </div>
                </div>

              </div>

              <div v-if='menu.isActive && menu.subMenu !== undefined && menu.subMenu !== null' class="navigation_menu_arrow_container">
                <div class="navigation_menu_arrow flex_display_centered_child">
                </div>
              </div>
              <div v-if='menu.isActive && menu.subMenu !== undefined && menu.subMenu !== null' class="navigation_menu_panel flex_display" v-clickoutside="toggleClose" v-bind:class="{ right_aligned: !menu.subMenu.menuLeftAlign }">
                <div v-if='menu.subMenu.iconMenus' class="navigation_menu_panel_left flex_display">
                  <div class="navigation_menu_panel_left_title"></div>
                  <div v-for="iconMenu in menu.subMenu.iconMenus" class="navigation_menu_icon">
                    <div class="navigation_menu_icon_container flex_display">
                      <div class="navigation_panel_circle_style flex_display flex_display_centered_child">
                        <span class="navigation_panel_circle_style_label flex_display_centered_child">
                          <i v-bind:class="iconMenu.iconName" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                    <div class="navigation_menu_icon_label_container flex_display">
                      <div class="navigation_menu_icon_label">
                        {{iconMenu.displayName}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if='menu.id === 999 && menu.show' v-bind:id="menu.module" class="navigation_menu" v-bind:class="{ menu_active: menu.isActive, menu_hide: !menu.isActive }">
              <div v-on:click="toggle(menu.module, $event)" class="flex_display navigation_menu_label_container">
                <span class="navigation_menu_label flex_display_centered_child">
                  {{menu.displayName}}
                </span>
                <span v-if='menu.subMenu !== undefined && menu.subMenu !== null' class="dropdown_arrow_small flex_display_centered_child navigation_menu_dropdown_arrow" v-bind:class="{ dropup_arrow: menu.isActive }"></span>
              </div>

              <div class="navigation_menu_arrow_container">
                <div class="navigation_menu_arrow flex_display_centered_child">
                </div>
              </div>
              <div class="navigation_menu_panel viewmore_menu flex_display" v-if='menu.isActive' v-clickoutside="toggleClose">
                <div class="navigation_menu_panel_right">
                  <div class="navigation_viewmore_menu_list">

                    <ul class="viewmore_menu_main_menu">
                      <li
                        v-for="viewMoreMenu in menus"
                        v-if="viewMoreMenu.module !== 'viewmore' && !viewMoreMenu.show"
                        v-bind:id="viewMoreMenu.module + '_list'"
                        class="viewmore_menu_main_menu_item"
                        v-bind:class="{ viewmore_menu_active: viewMoreMenu.isActive, viewmore_menu_hide: !viewMoreMenu.isActive }">

                        <div v-if='viewMoreMenu.subMenu !== undefined && viewMoreMenu.subMenu !== null' v-on:click="viewMoreMenuToggle(viewMoreMenu.module)" class="viewmore_menu_main_menu_item_label flex_display">
                          <div class="viewmore_menu_main_menu_item_text div_aline_left">
                            {{viewMoreMenu.displayName}}
                          </div>
                          <div class="flex_display notification_dropdown_menu_expand_arrow div_aline_right">
                            <div v-if='viewMoreMenu.subMenu !== undefined && viewMoreMenu.subMenu !== null' class="flex_display_centered_child flex_display" v-bind:class="{ open: viewMoreMenu.isActive }">
                              <span class="notification_dropdown_menu_expand_arrow_left"></span>
                              <span class="notification_dropdown_menu_expand_arrow_right"></span>
                            </div>
                          </div>
                        </div>

                        <div v-else class="viewmore_menu_main_menu_item_label flex_display">
                          <div class="viewmore_menu_main_menu_item_text div_aline_left">{{viewMoreMenu.displayName}}</div>
                        </div>

                        <ul v-if='viewMoreMenu.isActive && viewMoreMenu.subMenu !== undefined && viewMoreMenu.subMenu !== null' class="viewmore_menu_submenu">
                          <li class="viewmore_menu_submenu_item" v-for="viewMoreSubmenuMenu in viewMoreMenu.subMenu.iconMenus">
                            <div class="viewmore_submenu_item_container flex_display">
                              <div class="viewmore_submenu_item_icon flex_display">
                                <i class="flex_display_centered_child" v-bind:class="viewMoreSubmenuMenu.iconName" aria-hidden="true"></i>
                              </div>
                              <div  class="viewmore_submenu_item_label">
                                {{viewMoreSubmenuMenu.displayName}}
                              </div>
                            </div>
                          </li>
                        </ul>

                      </li>
                    </ul>

                  </div>
                </div>
              </div>
            </div>
            <div id="invisibleMenu" class="navigation_menu invisible_menu">
              Invisible for Length Calculate
            </div>
          </div>
          <div id="tnRightMenu" class="flex_display div_aline_right">
            <div class="navigation_menu_editor flex_display_centered_child">
              <div class="navigation_edit_pencil_container flex_display">
                <div class="navigation_circle_style navigation_edit_pencil flex_display flex_display_centered_child" v-on:click="toggleMenuEditor()">
                <span>
                  <i v-if="!editingMenu" class="fas fa-pencil-alt" aria-hidden="true"></i>
                  <i v-if="editingMenu" class="fas fa-ban" aria-hidden="true"></i>
                </span>
                </div>
              </div>
              <div v-if="editingMenu" class="navigation_menu_arrow_container navigation_menu_editor_arrow">
                <div class="navigation_menu_arrow flex_display_centered_child">
                </div>
              </div>
              <div v-if="editingMenu" class="navigation_menu_panel navigation_menu_edit_panel">
                <div class="navigation_menu_edit_panel_header flex_display">
                  <Span>Navigation Order</Span>
                </div>
                <ul>
                  <draggable @start="startDrag" @end="endDrag" :options="{handle:'.drag_handle'}">
                    <li class="drag_list flex_display" v-for="menucp2 in menus" v-if='menucp2.id !== 999' :key="menucp2.id">
                      <div class="drag_label">
                        {{menucp2.displayName}}
                      </div>
                      <div class="drag_handel_container flex_display">
                        <span class="drag_handle"></span>
                      </div>
                    </li>
                  </draggable>
                </ul>
                <div class="navigation_menu_edit_panel_footer flex_display">
                  <div class="navigation_menu_edit_panel_footer_left">
                    <button class="footer_link neon_btn_sm neon_btn_link neon_button_link_normal" v-on:click="rollBackMenuChanges()">
                      Reset
                    </button>
                  </div>
                  <div class="navigation_menu_edit_panel_footer_right">
                    <button class="footer_link neon_btn_sm neon_btn_primary neon_btn_default neon_button_link_submit" v-on:click="saveMenuChanges()">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <notificationCenter :panelActive="notificationCenterActive" @xoxoxox="hideDialog"></notificationCenter>
    <transition name="bounceLeft">
      <div v-if='miniMenu' v-responsive.sm.xs id="miniMenu" >
        <div id="miniMenuHeader" class="mini_menu_header flex_display">
          <div class="div_aline_left flex_display mini_my_account_container">
            <div id="miniTnInformation" class="div_aline_left">
              <div class="navigation_full_name">
                Edward Nicholas Shen
              </div>
              <div class="mini_navigation_logout">
                <a href="#">log out</a>
              </div>
            </div>
            <div v-on:click="miniMenuToggle('myAccount')" id="miniTnMyAccount" class="div_aline_right flex_display">
              <div class="dropdown_arrow_small flex_display_centered_child">
              </div>
            </div>
          </div>

          <div class="div_aline_right">
            <div class="icons">
              <div class="icon-box">
                <svg v-on:click="toggleMiniMenu" class="icon-close scale" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><title>Close</title><polygon points="12 1.4 10.6 0 6 4.6 1.4 0 0 1.4 4.6 6 0 10.6 1.4 12 6 7.4 10.6 12 12 10.6 7.4 6 12 1.4"/></svg>
              </div>
            </div>
          </div>
        </div>

        <div class="mini_menu_content">
          <div v-if='miniMyAccountMenu' class="mini_my_account">
            <ul class="mini_menu_submenu mini_my_account_menu">
              <li class="mini_menu_submenu_item " href="#">Sign-in & Security</li>
              <li class="mini_menu_submenu_item" href="#">Action Log</li>
            </ul>
          </div>
          <div class="mini_menu_overflow_container">
            <ul class="mini_menu_main_menu">
              <li
                v-for="miniMenu in menus"
                v-if='miniMenu.id !== 999 && miniMenu.show'
                v-bind:id="'miniMenu_'+miniMenu.module"
                v-bind:class="{ mini_menu_active: miniMenu.isActive, mini_menu_hide: !miniMenu.isActive }"
                class="mini_menu_main_menu_item">

                <div v-if='miniMenu.subMenu !== undefined && miniMenu.subMenu !== null' v-on:click="miniMenuToggle(miniMenu.module)" class="mini_menu_main_menu_item_label flex_display">
                  <div class="mini_menu_main_menu_item_text div_aline_left">{{miniMenu.displayName}}</div>
                  <div class="flex_display notification_dropdown_menu_expand_arrow div_aline_right">
                    <div v-if='miniMenu.subMenu !== undefined && miniMenu.subMenu !== null' class="flex_display_centered_child flex_display" v-bind:class="{ open: miniMenu.isActive }">
                      <span class="notification_dropdown_menu_expand_arrow_left"></span>
                      <span class="notification_dropdown_menu_expand_arrow_right"></span>
                    </div>
                  </div>
                </div>

                <div v-else class="mini_menu_main_menu_item_label flex_display">
                  <div class="mini_menu_main_menu_item_text div_aline_left">{{miniMenu.displayName}}</div>
                </div>

                <ul v-if='miniMenu.isActive && miniMenu.subMenu !== undefined && miniMenu.subMenu !== null' class="mini_menu_submenu">
                  <li class="mini_menu_submenu_item" v-for="miniSubMenu in miniMenu.subMenu.iconMenus">{{miniSubMenu.displayName}}</li>
                </ul>

              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import notificationCenter from '../../components/NotificationCenter'
  import fontawesome from '@fortawesome/fontawesome'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import solid from '@fortawesome/fontawesome-free-solid'
  import draggable from 'vuedraggable'
  import FontLoaded from 'font-loaded'
  import Multiselect from 'vue-multiselect'
  import '@/assets/js/zendesk'
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import SessionContext from '@/assets/js/sessionContext.js'

  require('vue2-animate/dist/vue2-animate.min.css')
  require('@/assets/css/mini_menu.css')

  var fontLoaded = new FontLoaded('Lato')

  fontLoaded.on('load', fontName => {
    window.dispatchEvent(new Event('resize'))
  })

  fontLoaded.on('error', fontName => {
    window.dispatchEvent(new Event('resize'))
  })

  fontawesome.library.add(solid)
  const clickoutside = {
    inserted (el, binding, vnode) {
      function documentHandler (e) {
        if (document.getElementById('titanNavigation').style.display !== undefined && document.getElementById('titanNavigation').style.display === 'none') {
          return false
        }
        if (document.getElementById('tnLeftMenu').contains(e.target)) {
          return false
        }

        if (binding.expression) {
          binding.value()
        }
      }

      el.__vueClickOutside__ = documentHandler
      document.addEventListener('click', documentHandler)
    },
    update () {
    },
    unbind (el, binding) {
      document.removeEventListener('click', el.__vueClickOutside__)
      delete el.__vueClickOutside__
    }
  }

  export default {
    name: 'neon-header',
    data () {
      return {
        searchResults: [],
        userContext: SessionContext.getUserContext(),
        clientWidth: document.body.clientWidth,
        firstMenuWidth: 0,
        menus: [
          {
            id: 1,
            module: 'dashboard',
            displayName: 'Dashboard',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Dashboard menu panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Mission Control',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-rocket'
                },
                {
                  id: 2,
                  displayName: 'Accounts',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-user'
                },
                {
                  id: 3,
                  displayName: 'Communications',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-bullhorn'
                },
                {
                  id: 4,
                  displayName: 'Events',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-calendar'
                },
                {
                  id: 5,
                  displayName: 'Fundraising',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-piggy-bank'
                },
                {
                  id: 6,
                  displayName: 'Membership',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-id-card'
                },
                {
                  id: 7,
                  displayName: 'Reports',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-chart-line'
                },
                {
                  id: 8,
                  displayName: 'Store',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-shopping-cart'
                }
              ]
            }
          },
          {
            id: 2,
            module: 'accounts',
            displayName: 'Accounts',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Account menu panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Accounts',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-user'
                },
                {
                  id: 2,
                  displayName: 'Households',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-home'
                }
              ]
            }
          },
          {
            id: 3,
            module: 'fundraising',
            displayName: 'Fundraising',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Fundraising menu panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Donations & Pledges',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-hand-holding-heart'
                },
                {
                  id: 2,
                  displayName: 'Tributes',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-ribbon'
                },
                {
                  id: 3,
                  displayName: 'Recurring Donation Schedules',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-user-clock'
                },
                {
                  id: 4,
                  displayName: 'Fundraising Campaign',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-bullhorn'
                },
                {
                  id: 5,
                  displayName: 'Social Fundraising Campaigns',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-user-friends'
                },
                {
                  id: 6,
                  displayName: 'Batch Donation Entry',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-table'
                }
              ]
            }
          },
          {
            id: 4,
            module: 'members',
            displayName: 'Members',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Member menu panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'New Individual Member',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-id-card'
                },
                {
                  id: 2,
                  displayName: 'New Organization Member',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-building'
                }
              ]
            }
          },
          {
            id: 5,
            module: 'Events',
            displayName: 'Events',
            isActive: false,
            show: true,
            width: 0
          },
          {
            id: 6,
            module: 'reports',
            displayName: 'Reports',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Report menu panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'New Report',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-plus'
                },
                {
                  id: 2,
                  displayName: 'One-click Report',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-hand-point-up'
                },
                {
                  id: 3,
                  displayName: 'Executive Reports',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-trophy'
                },
                {
                  id: 4,
                  displayName: 'Saved Reports',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-save'
                },
                {
                  id: 5,
                  displayName: 'Auto Reports',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-magic'
                }
              ]
            }
          },
          {
            id: 7,
            module: 'emails',
            displayName: 'Emails',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Email menu panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Email Audiences',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-bullseye'
                },
                {
                  id: 2,
                  displayName: 'Campaign Emails',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-bullhorn'
                },
                {
                  id: 3,
                  displayName: 'Schedule & Send',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-clock'
                },
                {
                  id: 4,
                  displayName: 'Campaign Monitoring & History',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-history'
                },
                {
                  id: 5,
                  displayName: 'Statistics',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-chart-pie'
                },
                {
                  id: 6,
                  displayName: 'Sent Emails',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-share-square'
                }
              ]
            }
          },
          {
            id: 77,
            module: 'letters',
            displayName: 'Letters',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Email menu panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Letter Merge',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-project-diagram'
                },
                {
                  id: 2,
                  displayName: 'Campaign Letters',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-envelope'
                }
              ]
            }
          },
          {
            id: 8,
            module: 'store',
            displayName: 'Store',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Store menu Panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Orders',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-tasks'
                },
                {
                  id: 2,
                  displayName: 'Products',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-tag'
                },
                {
                  id: 3,
                  displayName: 'Inventory',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-clipboard-check'
                },
                {
                  id: 4,
                  displayName: 'Catalogs',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-book-open'
                },
                {
                  id: 5,
                  displayName: 'Settings',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-cog'
                }
              ]
            }
          },
          {
            id: 9,
            module: 'volunteers',
            displayName: 'Volunteers',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Volunteer menu panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Projects',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-folder-open'
                },
                {
                  id: 2,
                  displayName: 'Applicants',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-file-alt'
                },
                {
                  id: 3,
                  displayName: 'Volunteers',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-user-alt'
                },
                {
                  id: 4,
                  displayName: 'Groups',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-users'
                },
                {
                  id: 5,
                  displayName: 'Time Sheets',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-clock'
                }
              ]
            }
          },
          {
            id: 10,
            module: 'paymentProcessing',
            displayName: 'Payment Processing',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Payment Processing menu panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Verify Your Account',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-user-check'
                },
                {
                  id: 2,
                  displayName: 'Payments',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-hand-holding-usd'
                },
                {
                  id: 3,
                  displayName: 'Payouts',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-user'
                },
                {
                  id: 4,
                  displayName: 'Disputes',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-exclamation-triangle'
                },
                {
                  id: 5,
                  displayName: 'Balance',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-balance-scale'
                },
                {
                  id: 6,
                  displayName: 'Settings',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-cog'
                }
              ]
            }
          },
          {
            id: 11,
            module: 'constantcontact',
            displayName: 'Constant Contact',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Constant Contact menu panel',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Getting Started',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-question-circle'
                },
                {
                  id: 2,
                  displayName: 'Lists',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-list'
                },
                {
                  id: 3,
                  displayName: 'Stats',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-chart-pie'
                },
                {
                  id: 4,
                  displayName: 'Sync',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-sync'
                },
                {
                  id: 5,
                  displayName: 'Settings',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-cog'
                }
              ]
            }
          },
          {
            id: 12,
            module: 'files',
            displayName: 'Files',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'File menu',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Files',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-file'
                },
                {
                  id: 2,
                  displayName: 'File Manager',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-cogs'
                }
              ]
            }
          },
          {
            id: 13,
            module: 'webContent',
            displayName: 'Web Content',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Web Content menu',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Form Links & Landing Pages',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-link'
                },
                {
                  id: 2,
                  displayName: 'Custom Forms',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-file-signature'
                },
                {
                  id: 3,
                  displayName: 'Custom Web Pages',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-globe'
                },
                {
                  id: 4,
                  displayName: 'News Posts',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-newspaper'
                }
              ]
            }
          },
          {
            id: 14,
            module: 'tools',
            displayName: 'Tools',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'File menu',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Import Manager',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-download'
                },
                {
                  id: 2,
                  displayName: 'Duplicate Manager',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-copy'
                },
                {
                  id: 3,
                  displayName: 'Action Log',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-list-ul'
                },
                {
                  id: 4,
                  displayName: 'Workflows',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-filter'
                },
                {
                  id: 5,
                  displayName: 'Data Backup Utility',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-database'
                },
                {
                  id: 6,
                  displayName: 'Manage Deposits',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-donate'
                }
              ]
            }
          },
          {
            id: 15,
            module: 'engagement',
            displayName: 'Engagement',
            isActive: false,
            show: true,
            width: 0,
            subMenu: {
              menuLeftAlign: true,
              iconMenuTitle: 'Engagement menu',
              iconMenus: [
                {
                  id: 1,
                  displayName: 'Activities',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-clipboard-list'
                },
                {
                  id: 2,
                  displayName: 'Grants',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-donate'
                },
                {
                  id: 3,
                  displayName: 'Prospects',
                  url: 'https://www.google.com',
                  iconName: 'fas fa-binoculars'
                }
              ]
            }
          },
          {
            id: 999,
            module: 'viewmore',
            displayName: 'View More',
            isActive: false,
            show: true,
            width: 0
          }
        ],
        getLengthText: 'whatever',
        createMenuIsActive: false,
        myAccountMenuIsActive: false,
        editingMenu: false,
        notificationCenterActive: false,
        miniMyAccountMenu: false,
        miniMenu: false,
        miniSearchBox: false
      }
    },
    components: {
      FontAwesomeIcon,
      draggable,
      notificationCenter,
      FontLoaded,
      Multiselect
    },
    directives: {
      clickoutside
    },
    methods: {
      jumpMenu: function (menuId) {
        alert(menuId)
        if (menuId === 1) {
          location.href = '/about.html'
        } else if (menuId === 2) {
          location.href = '/index.html'
        } else {
          alert('No Page')
        }
      },
      toggleMiniMenu: function () {
        this.miniMenu = !this.miniMenu
      },
      toggle: function (module, event) {
        for (var index in this.menus) {
          if (this.menus[index].module === module) {
            if (document.getElementById(module).contains(event.target)) {
              if (event.target.classList.contains('navigation_menu') ||
                event.target.classList.contains('navigation_menu_label') ||
                event.target.classList.contains('navigation_menu_dropdown_arrow')) {
                this.menus[index].isActive = !this.menus[index].isActive
              }
            } else {
              this.menus[index].isActive = !this.menus[index].isActive
            }
          } else {
            console.log('in toggle')
            console.log(event.target.classList)
            this.menus[index].isActive = false
          }
        }
      },
      toggleClose: function () {
        for (var index in this.menus) {
          console.log('in toggleClose')
          this.menus[index].isActive = false
        }
      },
      miniMenuToggle: function (module) {
        if (module === 'myAccount') {
          this.miniMyAccountMenu = !this.miniMyAccountMenu
          for (var index in this.menus) {
            console.log('in miniMenuToggle my account ')
            this.menus[index].isActive = false
          }
        } else {
          for (var index2 in this.menus) {
            if (this.menus[index2].module === module) {
              this.menus[index2].isActive = !this.menus[index2].isActive
            } else {
              console.log('in miniMenuToggle')
              this.menus[index2].isActive = false
            }
          }
          this.miniMyAccountMenu = false
        }
      },
      viewMoreMenuToggle: function (module) {
        for (var index in this.menus) {
          if (this.menus[index].module === module) {
            this.menus[index].isActive = !this.menus[index].isActive
          } else if (this.menus[index].module === 'viewmore') {
            // do nothing
          } else {
            console.log('in viewMoreMenuToggle')
            this.menus[index].isActive = false
          }
        }
      },
      hidenc: function () {
        this.notificationCenterActive = !this.notificationCenterActive
      },
      hideDialog: function () {
        this.notificationCenterActive = false
      },
      shakeit: function () {
        if (document.getElementsByClassName('notification_shake_number')[0].classList.contains('shake')) {
          document.getElementsByClassName('notification_shake_number')[0].classList.remove('shake')
        } else {
          document.getElementsByClassName('notification_shake_number')[0].classList.add('shake')
        }
      },
      toggleCreateMenu: function () {
        this.createMenuIsActive = true
      },
      toggleMyAccountMenu: function () {
        this.myAccountMenuIsActive = true
      },
      toggleMiniSearchBox: function () {
        this.miniSearchBox = !this.miniSearchBox
      },
      closeCreateMenu: function () {
        this.createMenuIsActive = false
      },
      toggleMenuEditor: function () {
        this.editingMenu = !this.editingMenu
        if (this.editingMenu) {
          this.cloneMenus = JSON.parse(JSON.stringify(this.menus))
        } else {
          this.cloneMenus = null
        }
      },
      closeMyAccountMenu: function () {
        this.myAccountMenuIsActive = false
      },
      rollBackMenuChanges: function () {
        this.cloneMenus = JSON.parse(JSON.stringify(this.menus))
      },
      saveMenuChanges: function () {
        this.menus = JSON.parse(JSON.stringify(this.cloneMenus))
        this.cloneMenus = null
        this.handleResize()
        this.editingMenu = false
      },
      endDrag: function (evt) {
        if (this.cloneMenus === undefined || this.cloneMenus === null) {
          this.cloneMenus = JSON.parse(JSON.stringify(this.menus))
        }

        if (evt.newIndex !== evt.oldIndex) {
          var oldNodeTemp = JSON.parse(JSON.stringify(this.cloneMenus[evt.oldIndex]))
          this.cloneMenus.splice(evt.oldIndex, 1)
          this.cloneMenus.splice(evt.newIndex, 0, oldNodeTemp)
        }
      },
      getMenuLenght: function (displayName) {
        document.getElementById('invisibleMenu').innerText = displayName
        return document.getElementById('invisibleMenu').clientWidth
      },
      handleResize: function () {
        var screenWidth = document.body.clientWidth
        var rightIconsWidth = document.getElementById('tnRightMenu').clientWidth
        var menuMaxWidth = screenWidth - rightIconsWidth
        var totalMenuWidth = 0
        var totalWidth = this.getMenuLenght('View More')

        for (var index in this.menus) {
          var arrow = 0
          if (this.menus[index].subMenu !== undefined && this.menus[index].subMenu !== null) {
            arrow = 18
            /* if menu contains arrow */
          }
          if (this.menus[index].width === 0) {
            var textWidth = this.getMenuLenght(this.menus[index].displayName) + arrow
            this.menus[index].width = textWidth
          }
          if (this.menus[index].module !== 'viewmore') {
            totalMenuWidth = this.getMenuLenght(this.menus[index].displayName) + totalMenuWidth + arrow
          }
        }

        if (totalMenuWidth < menuMaxWidth) {
          totalWidth = 0
          for (var inx in this.menus) {
            if (this.menus[inx].module === 'viewmore') {
              this.menus[inx].show = false
            }
          }
        } else {
          for (var inx2 in this.menus) {
            if (this.menus[inx2].module === 'viewmore') {
              this.menus[inx2].show = true
            }
          }
          totalWidth = this.getMenuLenght('View More')
        }

        for (var index3 in this.menus) {
          var arrowWidth = 0
          if (this.menus[index3].subMenu !== undefined && this.menus[index3].subMenu !== null) {
            arrowWidth = 18
            /* if menu contains arrow */
          }

          console.log(this.menus[index3].module)
          console.log(arrowWidth)

          if (this.menus[index3].module !== 'viewmore' && totalWidth + arrowWidth + this.getMenuLenght(this.menus[index3].displayName) > menuMaxWidth) {
            this.menus[index3].show = false
          } else if (this.menus[index3].module !== 'viewmore') {
            this.menus[index3].show = true
            if (this.menus[index3].subMenu !== undefined && this.menus[index3].subMenu !== null) {
              if (menuMaxWidth - totalWidth < 300) {
                this.menus[index3].subMenu.menuLeftAlign = false
              } else {
                this.menus[index3].subMenu.menuLeftAlign = true
              }
            }
          }

          if (this.menus[index3].module !== 'viewmore') {
            totalWidth = this.getMenuLenght(this.menus[index3].displayName) + totalWidth + arrowWidth
          }
          console.log(totalWidth)
        }
      },
      getResult: function () {
        this.isLoading = true
        fetch('https://jsonplaceholder.typicode.com/posts/1').then(response => {
          this.searchResults = [
            {

              type: 'Accounts',
              displayName: 'Accounts',
              isGroup: true,
              results: [
                {
                  isGroup: false,
                  type: 'Accounts',
                  trackId: 'account-2',
                  accountId: '2',
                  fullName: 'Jaina Proudmoore',
                  displayName: 'Jaina Proudmoore',
                  accountType: 'individual',
                  isShowMore: false,
                  address1: '',
                  addressLocate: ''
                },
                {
                  isGroup: false,
                  type: 'Accounts',
                  trackId: 'account-3',
                  accountId: '3',
                  fullName: 'Sylvanas Windrunner',
                  displayName: 'Sylvanas Windrunner',
                  accountType: 'individual',
                  isShowMore: false,
                  address1: '',
                  addressLocate: ''
                },
                {
                  isGroup: false,
                  type: 'Accounts',
                  trackId: 'account-4',
                  accountId: '4',
                  fullName: 'Valeera Sanguinar',
                  displayName: 'Valeera Sanguinar',
                  accountType: 'individual',
                  isShowMore: false,
                  address1: '',
                  addressLocate: ''
                },
                {
                  isGroup: false,
                  type: 'Accounts',
                  trackId: 'account-6',
                  accountId: '6',
                  fullName: 'Alexstrasza',
                  displayName: 'Alexstrasza',
                  accountType: 'individual',
                  isShowMore: false,
                  address1: '',
                  addressLocate: ''
                },
                {
                  isGroup: false,
                  type: 'Accounts',
                  trackId: 'account-5',
                  accountId: '5',
                  fullName: 'Venture Co.',
                  displayName: 'Venture Co.',
                  accountType: 'organization',
                  isShowMore: false,
                  address1: '',
                  addressLocate: ''
                },
                {
                  isGroup: false,
                  isShowMore: true,
                  showMoreLink: 'ssssss',
                  type: 'showMore'
                }
              ]
            },
            {
              type: 'Households',
              isGroup: true,
              results: [
                {
                  type: 'Households',
                  trackId: 'household-1',
                  householdId: '1',
                  householdName: 'Stormrage Family',
                  displayName: 'Stormrage Family',
                  householdDescription: 'What\'s this?',
                  isShowMore: false
                },
                {
                  type: 'Households',
                  trackId: 'household-2',
                  householdId: '2',
                  householdName: 'The Flintstones',
                  displayName: 'The Flintstones',
                  householdDescription: 'What\'s this?',
                  isShowMore: false
                },
                {
                  isGroup: false,
                  isShowMore: true,
                  showMoreLink: 'ssssss',
                  type: 'showMore'
                }
              ]
            },
            {
              type: 'Events',
              isGroup: true,
              results: [
                {
                  type: 'Events',
                  trackId: 'event-1',
                  eventId: '1',
                  eventName: 'Blizzcon 2018',
                  displayName: 'Blizzcon 2018',
                  eventDescription: 'What\'s this?',
                  isShowMore: false
                },
                {
                  type: 'Events',
                  trackId: 'event-2',
                  eventId: '2',
                  eventName: 'E3',
                  displayName: 'E3',
                  eventDescription: 'What\'s this?',
                  isShowMore: false
                },
                {
                  isGroup: false,
                  isShowMore: true,
                  showMoreLink: 'ssssss',
                  type: 'showMore'
                }
              ]
            },
            {
              type: 'Campaigns',
              isGroup: true,
              results: [
                {
                  type: 'Campaigns',
                  trackId: 'campaign-1',
                  campaignId: '1',
                  campaignName: 'Pokemon Go',
                  displayName: 'Pokemon Go',
                  campaignDescription: 'What\'s this?',
                  isShowMore: false
                },
                {
                  type: 'Campaigns',
                  trackId: 'campaign-2',
                  campaignId: '12',
                  campaignName: 'I have no idea',
                  displayName: 'I have no idea',
                  campaignDescription: 'What\'s this?',
                  isShowMore: false
                },
                {
                  isGroup: false,
                  isShowMore: true,
                  showMoreLink: 'ssssss',
                  type: 'showMore'
                }
              ]
            }
          ]
          this.isLoading = false
        })
      },
      closeSearch: function () {
        var multiselectActive = document.querySelectorAll('.neon_search_result .multiselect--active')[0]
        var multiselectWrapper = document.querySelectorAll('.neon_search_result .multiselect__content-wrapper')[0]
        multiselectWrapper.style.display = 'none'
        multiselectActive.classList.remove('multiselect--active')
        this.searchResults = []
      },
      clearResult: function () {
        var multiselectActive = document.querySelectorAll('.neon_search_result .multiselect--active')[0]
        var multiselectWrapper = document.querySelectorAll('.neon_search_result .multiselect__content-wrapper')[0]
        multiselectWrapper.style.display = 'none'
        multiselectActive.classList.remove('multiselect--active')
        this.searchResults = []
      }
    },
    mounted: function () {
      window.addEventListener('resize', this.handleResize)

      this.handleResize()
    }
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Lato:400,700&subset=latin-ext');
  @import url('https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i');
  @import url('https://use.fontawesome.com/releases/v5.1.0/css/all.css');

  header {
    position: relative;
    z-index: 2;
  }

  main {
  }

  footer {
    bottom: 0;
    width: 100%;
    height: 68px;
    border-top: 1px solid #e5e5e5;
  }

  #titanNavigation {
    background: #FDFDFD;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.14), 0 3px 4px 0 rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.20);
  }

  #app {
    font-family: Lato;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  #tnActions {
    background: #FDFDFD;
    border-bottom: 1px solid #E5E5E5;
  }

  #miniTnActions {
    background-color: #002D41;
  }

  #tnaLogo {
    height: 60px;
    width: 210px;
  }

  #miniTnLogo {
    height: 60px;
  }

  .navigation_logo {
    max-width: 100%;
    max-height: 100%;
    float: right;
    background-color: #002d41;
    padding: 15px;
  }

  #tnaSearchBox {
    position: relative;
    margin-left: 21px;
  }

  #tnaAdvancedSearchBox {
    height: 60px;
    line-height: 60px;
    margin-left: 14px;
    color: #002D41;
    cursor: pointer;
  }

  #tnaAdvancedSearchBox:hover {
    color: #0074d9;
  }

  #miniTnSearch {
    position: relative;
    height: 56px;
    line-height: 56px;
    background: #F4F6F9;
    box-shadow: 0 0 4px 0;
  }

  .mini_advanced_search_icon {
    position: absolute;
    top: 0px;
    right: 20px;
    cursor: pointer;
  }

  .mini_navigation_search_container {
    width: 100%;
    height: 100%;
    padding-left: 20px;
    padding-right: 45px;
  }

  .navigation_create_action_container {
    width: 32px;
    height: 32px;
  }

  .bootstrap_my_account {
    width: 100%;
  }

  .bootstrap_my_account .btn {
    width: 100%;
  }

  .navigation_circle_style {
    border: 1px solid #E5E5E5;
    border-radius: 16px;
    font-size: 14px;
    line-height: 16px;
    background-color: #fff;
    position: relative;
    color: #002D41;
    cursor: pointer;
    align-items: center;
    /*Center horizontaly */
    justify-content: center;
    /*Center horizontaly ie */
    -ms-flex-pack: center;
    -ms-flex-align: center;
  }

  .navigation_circle_style.transparent_bg {
    background-color: transparent;
    border: none;
    color: #fff;
  }

  .navigation_settings, .navigation_edit_pencil, .navigation_search, .navigation_menu_bar, .navigation_mini_icon {
    height: 32px;
    width: 32px;
    margin-left: 14px;
  }

  .navigation_create_action {
    background: #0074d9;
    color: #fff;
  }

  .navigation_settings:hover {
    background: #f8f9fa;
  }

  .navigation_settings.navigation_create_action:hover {
    background: #00539E;
  }

  .navigation_search.mini_search_active {
    color: #0074D9;
  }

  .navigation_menu_bar {
    margin-right: 14px;
  }

  .mini_navigation_notification_center {
    height: 32px;
    width: 32px;
    margin-top: 14px;
    margin-left: 14px;
    height: 32px;
    width: 32px;
    background: rgba(220,20,60,0.87);
    box-shadow: 0 0 2px 0 rgba(0,0,0,0.14), 0 2px 2px 0 rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20);
    color: #fff;
    border: none;
  }

  .mini_navigation_create_action {
    height: 32px;
    width: 32px;
    margin-left: 14px;
    margin-right: 14px;
    background: #0074D9;
    color: #fff;
    border: none;
  }

  .navigation_edit_pencil {
    margin-right: 14px;
  }

  #tnaIconNotification {
    margin-top: 14px;
    position: relative;
    margin-right: 14px;
  }

  #tnaMiniIconNotification {
    position: relative;
  }

  .notification_shake_number {
    width: 20px;
    top: -5px;
    position: absolute;
    right: -5px;
    font-size: 12px;
    background: rgba(220,20,60,0.87);
    box-shadow: 0 0 2px 0 rgba(0,0,0,0.14), 0 2px 2px 0 rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20);
    color: #fff;
  }

  .notification_mini_shake_number {
    width: 20px;
    top: 5px;
    position: absolute;
    right: -5px;
    font-size: 12px;
    background: rgba(220,20,60,0.87);
    box-shadow: 0 0 2px 0 rgba(0,0,0,0.14), 0 2px 2px 0 rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20);
    color: #fff;
  }

  #tnaVerticalLine {
    height: 32px;
    border-left: 1px solid;
    border-color: #E5E5E5;
    border-radius: 2px;
    margin-top: 14px;
    margin-left: 14px;
  }

  .navigation_full_name {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  #tnMenu {
    height: 60px;
  }

  #tnLeftMenu {
    position: relative;
  }

  #tnRightMenu {
    margin-left: auto;
    padding-right: 20px;
  }

  .navigation_menu_editor {
    height: 100%;
  }

  .navigation_edit_pencil_container {
    height: 100%;
  }

  .navigation_menu {
    height: 60px;
    padding-left: 30px;
    padding-right: 30px;
    color: #002D41;
    cursor: pointer;
    white-space:nowrap;
    position: relative;
  }

  .menu_active {
    color: #0074D9;
  }

  .navigation_menu:hover {
    color: #0074D9;
  }

  #tnaInformation {
    height: 32px;
    margin-top: 14px;
    margin-left: 14px;
    margin-right: 14px;
    font-size: 14px;
  }

  .navigation_logout {
    font-size: 12px;
    float: right;
  }

  .mini_navigation_logout {
    font-size: 12px;
    float: left;
  }

  .navigation_logout a {
    text-decoration-line: none;
  }

  .navigation_logout a:hover {
    text-decoration-line: none;
    color: #0074d9;
  }

  #tnaMyAccount {
    width: 32px;
    height: 32px;
    margin-right: 14px;
    margin-top: 14px;
    cursor: pointer;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  .dropdown_arrow {
    width: 0;
    height: 0;
    border-top: 5px solid #002D41;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    position: relative;
  }

  .dropdown_arrow_small {
    width: 0;
    height: 0;
    border-top: 4px solid #002D41;
    border-bottom: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    position: relative;
  }

  .dropdown_arrow_small.navigation_menu_dropdown_arrow {
  }

  .dropdown_arrow_small.navigation_menu_dropdown_arrow.dropup_arrow {
    width: 0;
    height: 0;
    border-top: 0;
    border-bottom: 4px solid #002D41;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    position: relative;
  }

  .navigation_dropdown ul {
    -webkit-padding-start: 0px;
    margin-bottom: 0px;
    margin-top: 0px;
    -webkit-padding-start: 0px;
    font-family: Lato;
    font-size: 16px;

  }

  .navigation_dropdown li {
    display: list-item;
    list-style-type: none;
    padding: 4px 24px;
    height: 40px;
    line-height: 40px;
    white-space: nowrap;
    text-align: left;
  }

  .navigation_dropdown li:hover {
    background-color: #f8f9fa;
  }

  .navigation_dropdown li:active {
    color: #fff;
    background-color: #007bff;
  }

  .navigation_menu_label {
    height: 24px;
  }

  .navigation_menu_label_container {
    height: 100%;
    position: relative;
  }

  .navigation_menu_label.has_submenu {
    padding-right: 20px;
    z-index: 20;
    height: 60px;
    line-height: 60px;
  }

  .notification_menu_expand_arrow {
    right: 0px;
    position: absolute;
    z-index: 1;
    margin-top: 26px;
  }

  .notification_dropdown_menu_expand_arrow {
    width: 30px;
    padding-right: 20px;
  }

  .navigation_menu_arrow_container {
    width: 100%;
    margin-top: -3px;
  }

  .navigation_menu_arrow {
    width: 0;
    height:0;
    border-bottom: 3px solid #0074D9;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    position:relative;
  }

  .navigation_menu_panel, .navigation_menu_edit_panel{
    position: absolute;
    background: #FFFFFF;
    border: 1px solid #DFE3E6;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.10);
    border-top: 4px solid #0074D9;
    cursor: default;
  }

  .navigation_menu_icon {
    cursor: pointer;
  }

  .navigation_menu_panel_left {
    width: 270px;
    padding: 21px 21px 30px 21px;
    flex-wrap: wrap;
    box-sizing: content-box;
  }

  .navigation_panel_circle_style {
    height: 48px;
    width: 48px;
    border-radius: 24px;
    font-size: 16px;
    line-height: 18px;
    background-color: #F4F6F9;
    position: relative;
    color: #002D41;
  }

  .navigation_panel_circle_style:after {
    position: absolute;
    pointer-events: none;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    content: '';
    box-sizing: content-box;
  }

  .navigation_panel_circle_style:after {
    top: -3px;
    left: -3px;
    padding: 3px;
    box-shadow: 0 0 0 4px #0074D9;
    transition: transform 0.2s, opacity 0.2s;
    transform: scale(.8);
    opacity: 0;
  }

  .navigation_panel_circle_style {
    transition: background 0.2s, color 0.2s;
  }

  .navigation_menu_icon:hover .navigation_panel_circle_style {
    background: #0074D9;
  }

  .navigation_menu_icon:hover .navigation_panel_circle_style:after {
    transform: scale(1);
    opacity: 1;
  }

  .navigation_menu_icon:hover .navigation_panel_circle_style .navigation_panel_circle_style_label {
    color: #fff;
  }

  .navigation_panel_circle_style_label {
    font-size: 20px;
    color: #002D41;
  }

  .navigation_menu_icon {
    width: 90px;
  }

  .navigation_menu_icon_label {
    font-size: 12px;
    white-space: normal;
    text-align: center;
    color: #3C4144;
    margin: 10px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .navigation_menu_icon:hover .navigation_menu_icon_label {
    color: #0074D9
  }

  .menu_hide .navigation_menu_panel {
    display: none;
  }

  .menu_active .navigation_menu_arrow_container {
    display: flex;
  }

  .menu_hide .navigation_menu_arrow_container {
    display: none;
  }

  .navigation_menu_panel_left_title {
    width: 100%;
    margin-bottom: 15px;
    margin-left: 18px;
    font-family: Lato;
    font-weight: 700;
    font-size: 14px;
    color: #002D41;
    letter-spacing: 1px;
    line-height: 36px;
  }

  .navigation_menu_panel_right_title {
    width: 100%;
    margin-bottom: 15px;
    font-family: Lato;
    font-weight: 700;
    font-size: 14px;
    color: #002D41;
    letter-spacing: 1px;
    line-height: 36px;
  }

  .navigation_menu_panel_right {
    padding: 21px 21px 30px 21px;
    background: #FBFBFD;
  }

  .navigation_menu_list ul {
    -webkit-padding-start: 0px;
  }

  .navigation_menu_list li {
    margin-bottom: 16px;
    display: list-item;
    cursor: pointer;
  }

  .navigation_menu_list li {
    height: 26px;
    line-height: 26px;
    color: #002D41;
    cursor: pointer;
    white-space: nowrap;
    display: list-item;
    list-style-type: none;
  }

  .navigation_menu_list li:hover {
    color: #0074d9;
  }

  .navigation_menu_edit_panel {
    right: 0px;
    position: absolute;
  }

  .navigation_menu_edit_panel ul {
    padding-left: 16px;
    padding-right: 16px;
  }

  .drag_list {
    position: relative;
    list-style-type: none;
    background-color: #fff;
    border: 1px solid #ddd;
    margin-bottom: 5px;
    margin-top: 5px;
    width: 210px;
  }

  .drag_label {
    width: 177px;
    margin: 5px 10px;
  }

  .drag_handel_container {
    height: 33px;
    width: 33px;
    border-left: 1px solid #ddd;
  }

  span.drag_handle {
    content: "....";
    width: 24px;
    height: 24px;
    display: inline-block;
    overflow: hidden;
    line-height: 4px;
    padding: 3px 4px;
    cursor: move;
    vertical-align: middle;
    font-size: 12px;
    font-family: sans-serif;
    letter-spacing: 2px;
    color: #ccc;
    text-shadow: 1px 0 1px #000;
    margin: auto;
  }
  span.drag_handle:hover {
    color: #0074d9;
    text-shadow: 1px 0 1px #0074d9;
  }

  span.drag_handle::after {
    content: '... ... ...';
  }

  .navigation_menu_edit_panel_header {
    height: 40px;
  }

  .navigation_menu_edit_panel_header span {
    height: 40px;
    line-height: 40px;
    margin-left: 10px;
  }

  .navigation_menu_edit_panel_footer {
    height: 40px;
    border-top: 1px solid #ddd;
  }

  .navigation_menu_edit_panel_footer_left {
    padding: 8px 10px;
  }

  .navigation_menu_edit_panel_footer_right {
    padding: 8px 10px;
    margin-left: auto;
  }

  .footer_link {
    font-size: 12px;
    text-decoration-line: none;
  }

  .neon_button_link {
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .neon_button_link_normal {
    color: #002d41;
  }

  .neon_button_link_submit {
    color: #0074d9;
  }

  .navigation_menu.invisible_menu {
    position: absolute;
    visibility: hidden;
  }

  .vue-tooltip.tooltip-custom .tooltip-arrow {
    display: none;
  }

  #notificationCenter {
    position: absolute;
    height: 100%;
    width: 600px;
    z-index: 10;
    background-color: #fff;
    right: 0px;
    top: 0px;
    box-shadow: 0 0 16px 0 rgba(0,0,0,0.24);
  }

  .viewmore_menu_main_menu, .viewmore_menu_submenu {
    -webkit-padding-start: 0px;
    margin-bottom: 0;
  }

  .viewmore_menu_main_menu_item {
    display: list-item;
    list-style-type: none;
    font-size: 16px;
    color: #002D41;
    letter-spacing: 0;
    text-align: left;
    cursor: pointer;
  }

  .viewmore_menu_main_menu_item_label {
    height: 48px;
    line-height: 48px;
    padding-left: 24px;
    border-bottom: 1px solid #D8DDE6;
  }

  .viewmore_menu_main_menu_item_text {
    width: 250px;
  }

  .viewmore_menu_main_menu_item_arrow {
    margin-right: 20px;
    color: #002D41;
    width: 20px;
  }

  .viewmore_menu_main_menu_item_label:hover {
    background-color: #0074D9;
    color: #fff;
  }

  .viewmore_menu_submenu_item {
    display: list-item;
    list-style-type: none;
    font-size: 14px;
    color: #002D41;
    letter-spacing: 0;
    text-align: left;
    height: 32px;
    line-height: 32px;
    padding: 2px 0px;
    cursor: pointer;
  }

  .navigation_menu_panel.viewmore_menu .navigation_menu_panel_right {
    padding: 0px;
  }

  .navigation_menu_panel.viewmore_menu {
    right: 0px;
  }

  .viewmore_menu_submenu li:hover {
    background-color: #F4F6F9;
    font-weight: 700;
  }

  .viewmore_menu_submenu {
    border-bottom: 1px solid #D8DDE6;
  }

  .viewmore_menu_active .viewmore_menu_main_menu_item_label {
    background-color: #0074D9;
    color: #fff;
  }

  .viewmore_submenu_item_icon {
    margin-left: 15px;
    margin-right: 15px;
    width: 20px;
  }

  .demo_search_select {
    width: 300px;
    position: relative;
  }

  .demo_search_select_mini {
    width: 100%;
    position: relative;
  }

  .shake {
    -webkit-animation-name: shaker;
    -webkit-animation-duration: 0.1s;
    -webkit-transform-origin:50% 50%;
    -webkit-animation-timing-function: linear;
  }
</style>



// WEBPACK FOOTER //
// src/modules/common/Header.vue